/** Énumération qui recense les mode possibles de tournée. */
export enum ETourneeMode {

	tournee = 1,
	planification
}